import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	name: {
		id: 'admin-pages-screens-page.screens-table.name',
		defaultMessage: 'Name',
		description: 'Screen name',
	},
	screenSchemes: {
		id: 'admin-pages-screens-page.screens-table.screen-schemes',
		defaultMessage: 'Screen Schemes',
		description: 'Screen Scheme title',
	},
	workflowTransitions: {
		id: 'admin-pages-screens-page.screens-table.workflow-transitions',
		defaultMessage: 'Workflows',
		description: 'Workflow title',
	},
	actions: {
		id: 'admin-pages-screens-page.screens-table.actions',
		defaultMessage: 'Actions',
		description: 'actions column title',
	},
	configure: {
		id: 'admin-pages-screens-page.screens-table.configure',
		defaultMessage: 'Configure',
		description: 'Configure action link text',
	},
	copy: {
		id: 'admin-pages-screens-page.screens-table.copy',
		defaultMessage: 'Copy',
		description: 'Copy action link text',
	},
	edit: {
		id: 'admin-pages-screens-page.screens-table.edit',
		defaultMessage: 'Edit',
		description: 'Edit action link text',
	},
	delete: {
		id: 'admin-pages-screens-page.screens-table.delete',
		defaultMessage: 'Delete',
		description: 'Delete action link text',
	},
	empty: {
		id: 'admin-pages-screens-page.screens-table.empty',
		defaultMessage: "We didn't find any screens that matched your search",
		description: 'Empty table message',
	},
});
